import * as React from "react";
const SvgFiRrCloudShare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-share_svg__a)">
      <path
        fill="#062147"
        d="M21 18c-.775 0-1.52.303-2.077.844l-2.96-1.481q.03-.18.037-.363a3 3 0 0 0-.037-.363l2.96-1.481A2.995 2.995 0 1 0 18 13q.007.182.037.363l-2.96 1.48a3 3 0 1 0 0 4.313l2.96 1.48q-.03.18-.037.364a3 3 0 1 0 3-3m0-6a1 1 0 1 1 0 1.999 1 1 0 0 1 0-2m-8 6a1 1 0 1 1 0-2.002A1 1 0 0 1 13 18m8 4a1 1 0 1 1 0-2.002A1 1 0 0 1 21 22m-9 0a1 1 0 0 1-1 1H5.68a5.84 5.84 0 0 1-5.623-4.7 5.44 5.44 0 0 1 2.885-5.651 7.65 7.65 0 0 1-.8-5.18 8 8 0 0 1 15.49-.842 1.09 1.09 0 0 0 .722.735 1 1 0 1 1-.588 1.91 3.1 3.1 0 0 1-2.044-2.052 6 6 0 1 0-11.06 4.513 1.994 1.994 0 0 1-.792 2.686 3.47 3.47 0 0 0-1.835 3.6 3.81 3.81 0 0 0 3.644 2.98H11a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-share_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudShare;
